<script lang="ts" setup>
import { PhArrowSquareOut } from '@phosphor-icons/vue';
import type { AllInvoicesTableInvoice } from './types';

const props = defineProps<{
  row: AllInvoicesTableInvoice;
  column: string;
  value: unknown;
}>();

const emit = defineEmits<{
  (e: 'navigate-to-project'): void;
}>();
</script>

<template>
  <div v-if="props.column === '_actions'" class="actions-cell">
    <button class="btn-go-to-invoice" @click.stop="emit('navigate-to-project')">
      <PhArrowSquareOut :size="16" />
    </button>
  </div>
  <template v-else>{{ props.value }}</template>
</template>

<style scoped lang="scss">
.actions-cell {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-go-to-invoice {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  line-height: 0;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 0, 0, 0.15);
  }
}
</style>
